export function isValidInputValue(value: string) {
  const rgx = /^[0-9]*\.?[0-9]{0,6}$/;
  return value?.match(rgx);
}
